module.exports = __webpack_public_path__ + "img/level-complete-bg-th.9de37c11.png";